import MapComponent from './components/map/map';
import DropdownComponent from './components/map-dropdown/map-dropdown';
import HoverComponent from './components/map-hover/map-hover';
import events from './components/map-events/map-events';

export const identifier = 'map-china';

export const Reds = [
    '#efdada',
    '#e69e9e',
    '#d46666',
    '#990000',
    '#5b0101',
];

export const Blues = [
    '#cfe1e5',
    '#a1ccd9',
    '#4ba7bc',
    '#1380a1',
    '#0b4d60',
];

const Grey = '#ccc';

export default class Map {
    constructor(rootElement, svgUrl, data) {
        this.data = this.regions(data);
        this.dom = {
            map: rootElement.querySelector('.vj-map-china'),
            dropdown: rootElement.querySelector('.vj-map-dropdown-china'),
            tooltip: rootElement.querySelector('.vj-map-tooltip'),
        };
        this.map = new MapComponent({
            svgUrl,
            rootElement: this.dom.map,
            zoomable: false,
            colors: { default: Grey, ...this.regionColours(this.data) },
            regionIdPrefix: '', // no prefix
            padding: 0.3, // padding when zoomed-in, example: 0.3; can also be negative.
            stroke: 1, // stroke around each path, in px.
            maxZoom: 0, // maximum zoom value: for example 10: 10x zoom, 0 to remove limit
            defaultRegionId: undefined, // region selected when component start
        }, identifier);
        this.dropdown = new DropdownComponent({
            rootElement: this.dom.dropdown,
            items: {
                ...this.regionNames(this.data),
                ZH: this.data['ZH'][`name-${__('lang')}`],
            },
        }, identifier);
        this.hover = new HoverComponent({ rootScope: rootElement.parentNode }, regionID => {
            const region = this.data[regionID];
            if (!region || regionID === 'CH') {
                this.dom.tooltip.classList.add('shrink');
                return;
            }
            this.dom.tooltip.classList.remove('shrink');
            this.dom.tooltip.innerHTML = region[`name-${__('lang')}`];
        }, identifier);
    }

    static async build(rootElement, svgURL, data) {
        const map = new Map(rootElement, svgURL, data);
        await map.map.init();

        map.dom.map.addEventListener('mouseup', () => {
            events.emit('vj-map', {
                type: 'region-changed',
                content: 'ZH',
                id: identifier,
            });
        });
        return map;
    }

    regions(data) {
        const { lastmod, ...regions } = data;
        return arrayToObject(Object.entries(regions)
            .map(keyval => {
                const [key, val] = keyval;
                return { [key]: val };
            }));
    }

    regionColours(regions) {
        const colours = arrayToObject(Object.entries(regions)
            .map(keyval => {
                const [regionID, { infected }] = keyval;
                return { [regionID]: this.colours(infected) };
            }));
        colours['CH'] = 'transparent';
        return colours;
    }

    regionNames(regions) {
        return arrayToObject(Object.entries(regions)
            .map(keyval => {
                const [regionID, region] = keyval;
                return { [regionID]: region[`name-${__('lang')}`] };
            }));
    }

    colours(value) {
        if (value === '' || value === 0) {
            return Grey;
        }
        if (value <= 100) {
            return Blues[0];
        }
        if (value <= 1000) {
            return Blues[1];
        }
        if (value <= 10000) {
            return Blues[2];
        }
        return Blues[3];
    }
}

function arrayToObject(array) {
    return array.reduce((result, obj) => ({ ...result, ...obj }), {});
}

